import {InjectionToken} from '@angular/core';

export const MarketplacePartnerToken = new InjectionToken<string>('Marketplace partner token for auth and api keys');
